const groups = {
  // Maps to Auth0 strings
  SUPER_ADMIN: 'Super Administrators',
};

const roles = {
  // Maps to Auth0 string
  ADMIN: 'Administrator',
  CORP_ADMIN: 'Corporate Administrator',
  CORP_REPORTER: 'Corporate Reporter',
  CORP_USER: 'Corporate User',
  VOL_ADMIN: 'Volunteer Administrator',
  VOL_USER: 'Volunteer User',
};

const roleMap = Object.keys(roles).reduce(
  (acc, key) => ({
    ...acc,
    [roles[key]]: key,
  }),
  {},
);

const hasProperAuthGroupsAndRoleStructure = user => {
  if (!user || !user.authorization || !user.authorization.roles || user.authorization.roles.length > 1) {
    return false;
  }

  return true;
};

const hasAdminRole = user => user.authorization.roles.indexOf(roles.ADMIN) > -1;
const hasCorpAdminRole = user => hasAdminRole(user) || user.authorization.roles.indexOf(roles.CORP_ADMIN) > -1;
const hasCorpUserRole = user => hasCorpAdminRole(user) || user.authorization.roles.indexOf(roles.CORP_USER) > -1;
const hasCorpReporterRole = user => hasCorpUserRole(user) || user.authorization.roles.indexOf(roles.CORP_REPORTER) > -1;
const hasVolunteerAdminRole = user =>
  hasCorpReporterRole(user) || user.authorization.roles.indexOf(roles.VOL_ADMIN) > -1;
const hasVolunteerUserRole = user =>
  hasVolunteerAdminRole(user) || user.authorization.roles.indexOf(roles.VOL_USER) > -1;

const hasSuperAdminAccess = user => hasProperAuthGroupsAndRoleStructure(user) && hasAdminRole(user);
const hasCorpAdminAccess = user => hasProperAuthGroupsAndRoleStructure(user) && hasCorpAdminRole(user);
const hasCorpUserAccess = user => hasProperAuthGroupsAndRoleStructure(user) && hasCorpUserRole(user);
const hasCorpReporterAccess = user => hasProperAuthGroupsAndRoleStructure(user) && hasCorpReporterRole(user);
const hasVolunteerAdminAccess = user => hasProperAuthGroupsAndRoleStructure(user) && hasVolunteerAdminRole(user);
const hasVolunteerUserAccess = user => hasProperAuthGroupsAndRoleStructure(user) && hasVolunteerUserRole(user);

const isNotSuperAdminGroup = group => group !== groups.SUPER_ADMIN;

const isSuperAdmin = user =>
  hasProperAuthGroupsAndRoleStructure(user) && user.authorization.roles.indexOf(roles.ADMIN) > -1;
const isCorpAdmin = user =>
  hasProperAuthGroupsAndRoleStructure(user) && user.authorization.roles.indexOf(roles.CORP_ADMIN) > -1;
const isCorpUser = user =>
  hasProperAuthGroupsAndRoleStructure(user) && user.authorization.roles.indexOf(roles.CORP_USER) > -1;
const isCorpReporter = user =>
  hasProperAuthGroupsAndRoleStructure(user) && user.authorization.roles.indexOf(roles.CORP_REPORTER) > -1;
const isVolunteerAdmin = user =>
  hasProperAuthGroupsAndRoleStructure(user) && user.authorization.roles.indexOf(roles.VOL_ADMIN) > -1;
const isVolunteerUser = user =>
  hasProperAuthGroupsAndRoleStructure(user) && user.authorization.roles.indexOf(roles.VOL_USER) > -1;

const getVenues = user => {
  if (!user || !user.authorization || !user.authorization.groups) {
    return [];
  }

  return user.authorization.groups.filter(isNotSuperAdminGroup);
};

export {
  hasSuperAdminAccess,
  hasCorpAdminAccess,
  hasCorpUserAccess,
  hasCorpReporterAccess,
  hasVolunteerAdminAccess,
  hasVolunteerUserAccess,
  isSuperAdmin,
  isCorpAdmin,
  isCorpUser,
  isCorpReporter,
  isVolunteerAdmin,
  isVolunteerUser,
  getVenues,
  roles,
  roleMap,
};



// WEBPACK FOOTER //
// ./src/lib/authorization.js